var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag is-dark is-rounded is-font-small",class:{ isRight: _vm.isRight },staticStyle:{"width":"fit-content"},style:({
		'background-color': _vm.tagColor,
		color: _vm.getColor(_vm.tagColor),
	})},[_vm._v(" "+_vm._s(_vm.tagName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }